import React, { useState, useEffect, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";

import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";

import { clearAlerts } from "../../store/actions/alerts";

const SEVERITIES = ["error", "warning", "info", "success"];

export default function Alerts() {
  const dispatch = useDispatch();
  const alerts = useSelector((state) => state.alerts);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (
      !!alerts.message &&
      !!alerts.severity &&
      SEVERITIES.includes(alerts.severity.toLowerCase())
    ) {
      setOpen(true);
    }
  }, [alerts]);

  function handleClose(event, reason) {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
    dispatch(clearAlerts());
  }

  return (
    <Fragment>
      {!!alerts.message &&
        !!alerts.severity &&
        SEVERITIES.includes(alerts.severity.toLowerCase()) && (
          <Snackbar
            anchorOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
            open={open}
            autoHideDuration={5000}
            onClose={handleClose}
          >
            <Alert
              onClose={handleClose}
              severity={alerts.severity.toLowerCase()}
            >
              {alerts.message}
            </Alert>
          </Snackbar>
        )}
    </Fragment>
  );
}
